import { inject, observer } from 'mobx-react';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { modelOf } from '../../../prop-types';
import AccountStore from '../../../store/AccountStore';
import ConfigStore from '../../../store/ConfigStore';
import UIStore from '../../../store/UIStore';
import RequestState from '../../../types/RequestState';

/**
 * This component simply watches for location changes and stores them.
 */
const RouteHistoryKeeper = ({ uiStore, configStore, accountStore }) => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    let previousPathname = location.pathname;

    const unlisten = history.listen((location, action) => {
      if (action !== 'REPLACE') {
        uiStore.setLastPathname(previousPathname);
        previousPathname = location.pathname;

        if (
          configStore.state === RequestState.LOADED &&
          configStore.store.loginRequired
        ) {
          checkLogin();
        }
      }
    });

    return () => {
      if (unlisten) {
        unlisten();
      }
    };
  }, [location, uiStore, configStore]);

  const checkLogin = () => {
    accountStore.loginCheck();
  };

  return null;
};

RouteHistoryKeeper.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  uiStore: modelOf(UIStore),
};

export default inject(
  'uiStore',
  'accountStore',
  'configStore'
)(observer(RouteHistoryKeeper));
